import React, { FC, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import EmployeePicker from "./EmployeePicker";
import { onAddSubordinate } from "../../../services/employee";
import { IoMdCheckbox } from "react-icons/io";
import { checkicon } from "../../../constant/import";

export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const departmentPickhook = usePickerhook();
  const { setLoading } = useStateSetter();
  const { AddEmployee } = useEmployeeHook();
  const { selectedOrgEmployees } = useEmployeeHook();
  const watchedFields = watch(["title", "description"]);
  const { SelectedOrg, config, selectedEmployee } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const [selectedSub, setselectedSub] = useState<any>([]);
  const areFieldsFilled = watchedFields.every( (field) =>
      field !== "" && field !== undefined && departmentPickhook.pickedRole
  );
  const onSubmit = async () => {
    await Promise.all(
      props.subordinates.map(async (item: any) => {

        
        let postdata = {
          lineManagerID: selectedSub[0].id,
          subOrdinateID: item.subordinate.id,
          organizationID: SelectedOrg.id,
        };

        try {
          setLoading(true);
          var res = await onAddSubordinate(postdata, config);
          toast.success(res.message);
        } catch (e: any) {
          toast.error(e);
        } finally {
          setLoading(false);
        }
      })
    );

    props.show(false);
    await props.refresh();
  };

  const employeepickHook = usePickerhook();

  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col gap-2 rounded-[8px] bg-white w-[40vw] p-4 ">

        <img width={40} height={40} className="self-center" src={checkicon}/>
        <div className="flex flex-col justify-center items-center">
            <p className="font-semibold self-center text-sm text-center">
              Confirm Unassignment
            </p>
            <p className="font-light self-start text-xs text-center">
              This action will impact their reporting structure and may leave
              them without a direct manager. Please review the options below to
              ensure continuity.
            </p>
          </div>
        

          <div className="">
          <p className="font-semibold self-start text-sm text-gray-500 ">
            Assign a New Manager
          </p>
            <EmployeePicker
              fullwidth
              ismanager={true}
              hook={employeepickHook}
              setselectedSub={setselectedSub}
              selectedSub={selectedSub}
              title="Manager"
              // List of all other employees except the line manager
              list={selectedOrgEmployees.filter(
                (k: any) => k.id != selectedEmployee.id && k.isLineManager
              )}
            />
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!(selectedSub.length > 0)}
              text="Add Subordinate"
              onBtnClick={onSubmit}
            />
          </div>
        </div>
      </div>
    </>
  );
};
